export const faqs = [
  {
    title: 'جیحون چه کاری انجام می دهد؟',
    description:
      'جیحون (ارزش گستران خلق ثروت) یک پلتفرم B2B تامین مالی برا بهبود نقدینگی در زنجیره تامین می باشد. در واقع جیحون در حوزه SCF یا همان Supply Chain Finance که تامین مالی در زنجیره تامین می باشد فعالیت می کند.',
  },
  {
    title: 'جیحون چطور کار می کند؟',
    description:
      'تبادلات مالی در جیحون از طریق صدور تعهد پرداخت از سوی شخص فروشنده به شخص خریدار در زنجیره تامین انجام می شود. به این صورت که شخص خریدار جهت پرداخت تعهد خود می تواند از ابزارهای گوناگون استفاده نماید.',
  },
  {
    title: 'تعهد پرداخت چیست؟',
    description:
      'سندی که به استناد فاکتور اعلامی‌ از سوی فروشنده از جانب این فرد برای فرد خریدار جهت پرداخت بدهی صادر شده و تمامی‌اطلاعات یک فاکتور از جمله مبلغ، سررسید پرداخت و … را در خود جای داده است. این سند در زنجیره قابل انتقال بوده و فروشنده می تواند آن را به حلقه های بالاتر منتقل نماید.',
  },
  {
    title: 'تعهد پرداخت چگونه نقد می شود؟',
    description:
      'در سرویس جیحون هر زمان که فرد فروشنده درخواست نماید، با تایید فرد خریدار، مبلغ تعهد پس از کسر هزینه زمانی پول  از طریق ابزارهای پرداخت، به حساب فرد فروشنده واریز می شود.',
  },
  {
    title: 'فروشنده با تعهد پرداخت چگونه کار می کند؟',
    description:
      'پس از ثبت فاکتورها چه به صورت سیستمی و یا دستی، فروشنده می تواند فاکتورها را تایید نموده و به تعهد پرداخت تبدیل نماید و در ادامه درخواست نقد سازی تعهد پرداخت را برای خریدار ارسال نماید.',
  },
  {
    title: 'خریدار با تعهد پرداخت چگونه کار می کند؟',
    description:
      'خریدار با دریافت تعهد پرداخت می تواند زمان سررسید تعهد پرداخت را تغییر داده و در کنار آن یکی از روش های اقساطی یا پرداخت یکجا را انتخاب نماید. به طور کلی خریدار می تواند یکی از سه روش پرداخت یکجا بدون زمان مازاد، یکجا با زمان مازاد و اقساطی از ابتدا را جهت پرداخت تعهدات خود انتخاب نماید.',
  },
  {
    title: 'نحوه پرداخت تعهد با دریافت تسهیلات چگونه است؟',
    description:
      'در سرویس جیحون فرد فروشنده با تعیین حد اعتبار برای افراد خریدار در زنجیره تامین خود مشخص می کند که هر فرد به چه میزان می تواند خرید مدت دار استفاده نماید. در اینجا فرد فروشنده نقش ضامن تسهیلات و فرد خریدار نقش دریافت کننده تسهیلات و متعهد به بازپرداخت تسهیلات را ایفا می کند.',
  },
]
